import { AodRun, GipReportDataDto } from '@app/modules/audit/modules/aod/aod.types';
import { CalendarToday } from '@mui/icons-material';
import { Box, Chip, Stack, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export type GipAodRun = Omit<AodRun, 'overrideExportConditions'> & {
  overrideReportConfig?: Partial<GipReportDataDto>;
};

interface Props {
  data: {
    overrideReportConfig?: Partial<GipReportDataDto>;
  };
}

export function AodGipRunDataPreview({ data }: Props) {
  const orders = data.overrideReportConfig?.orders ?? [];
  const { from, to } = data.overrideReportConfig ?? {};

  if (!orders.length) {
    return null;
  }

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    } catch {
      return dateString;
    }
  };

  const hasDateRange = from && to;

  return (
    <Box>
      <Stack direction="row" spacing={1} flexWrap="wrap" gap={1} alignItems="center">
        {orders.map((order, index) => (
          <Chip
            key={index}
            label={
              <Box>
                <Box
                  sx={{
                    fontSize: '0.6rem',
                    lineHeight: '.5rem',
                    color: 'text.secondary',
                    marginTop: '2px',
                  }}
                >
                  <FormattedMessage id="audit.aod.gip.order" defaultMessage="Orden" />
                </Box>
                <Box sx={{ fontSize: '0.7rem', fontWeight: 'medium' }}>{order}</Box>
              </Box>
            }
            icon={
              hasDateRange && index === orders.length - 1 ? (
                <Tooltip title={`Período: ${formatDate(from)} - ${formatDate(to)}`} arrow>
                  <CalendarToday sx={{ fontSize: '0.8rem' }} />
                </Tooltip>
              ) : undefined
            }
            size="small"
            variant="outlined"
            sx={{
              height: 'auto',
              paddingLeft: '8px',
              paddingRight: '2px',
              '.MuiChip-label': {
                padding: '2px 12px',
              },
            }}
          />
        ))}
      </Stack>
    </Box>
  );
}
